import { makeStyles } from "@material-ui/styles";

const syncFooterStyles = makeStyles((theme) => {
	return {
		syncFooterBox: {
			position: "absolute",
			bottom: 15,
			width: "100%",
			flexDirection: "row-reverse",
			display: "flex",
			justifyContent: "center",
			alignItems: "center",
			paddingLeft: "5px",
			paddingRight: "5px"
		},
		syncFooter: {
			padding: "3px 5px",
			color: ({ syncError }) => (syncError ? "#ce6460" : "#5bb06c")
		},
		syncIconFooter: {
			borderRadius: "5px",
			border: "1px solid rgba(255,255,255,0.1)",
			padding: "3px",
			"&.MuiIconButton-root": {
				color: ({ syncError }) => (syncError ? "#ce6460" : "#5bb06c")
			}
		},
		paper: {
			backgroundColor: theme.palette.menu.backgroundColor,
			border: "1px solid rgba(255,255,255,0.1)"
		},
		tooltip: {
			zIndex: theme.zIndex.tooltip
		},
		syncIconSyncing: {
			"&.MuiIconButton-root": {
				"& svg": {
					animation: "$spin 2s linear infinite"
				}
			}
		},
		"@keyframes spin": {
			"0%": { transform: "rotate(360deg)" },
			"100%": { transform: "rotate(0deg)" }
		},
		"@media (prefers-reduced-motion: reduce)": {
			syncIconSyncing: {
				"&.MuiIconButton-root": {
					"& svg": {
						animation: "none"
					}
				}
			}
		}
	};
});

export default syncFooterStyles;
